import { useSelector } from "react-redux";
import { hasAnyPermission, getFirstAllowedRoute } from "../../utils/permission";
import { Navigate } from "react-router-dom";
import React from "react";

const PermissionWrapper = ({ permissions, children, ...rest }) => {

    const permissionsFromUser = useSelector((state) => state.user.permissions);
    const company = useSelector((state) => state.user.company);

    if (hasAnyPermission(permissionsFromUser, permissions, company?.unitId)) {
        return children;
    }

    // Sem permissão para esta rota: manda para a primeira rota que o usuário
    // pode acessar em vez de encalhar no /403.
    return <Navigate to={getFirstAllowedRoute(permissionsFromUser, company?.unitId)} replace />;
};

export default PermissionWrapper;
